import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import OAuthConnectionService, { OAuthConnection } from '@/services/OAuthConnectionService';
import notificationService from '@/services/NotificationService';


export default /*#__PURE__*/_defineComponent({
  __name: 'DisconnectConnectionDialog',
  emits: ["disconnected"],
  setup(__props, { expose, emit }: { emit: ({
  (e: 'disconnected'): void;
}), expose: any, slots: any, attrs: any }) {

const visible = ref(false);
const loading = ref(false);
const connection = ref<OAuthConnection | null>(null);



const show = (conn: OAuthConnection) => {
  connection.value = conn;
  visible.value = true;
};

const close = () => {
  visible.value = false;
  connection.value = null;
};

const confirmDisconnect = async () => {
  if (!connection.value) return;

  loading.value = true;
  try {
    await OAuthConnectionService.disconnect(connection.value.id);
    notificationService.success('App disconnected successfully');
    emit('disconnected');
    visible.value = false;
  } catch (error) {
    notificationService.error('Failed to disconnect app. Please try again.');
  } finally {
    loading.value = false;
    connection.value = null;
  }
};

expose({ show });

return { __sfc: true,visible, loading, connection, emit, show, close, confirmDisconnect }
}

})